module.exports = "pegasus/assets/social-profile-preview-old.png";